"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileAPI = void 0;
class FileAPI {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    setToken(token) {
        this.token = token;
    }
    getHeaders(contentType = 'application/json') {
        const headers = {
            'Content-Type': contentType,
        };
        if (this.token) {
            headers['Authorization'] = `Bearer ${this.token}`;
        }
        return headers;
    }
    getFiles(folder) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = new URL(`${this.baseUrl}/api/s3/files`);
            if (folder) {
                url.searchParams.append('folder', folder);
            }
            const response = yield fetch(url.toString(), {
                headers: this.getHeaders(),
            });
            if (!response.ok) {
                const error = yield response.json().catch(() => ({}));
                throw new Error(error.message || '파일 목록 조회에 실패했습니다');
            }
            return response.json();
        });
    }
    getFileById(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`${this.baseUrl}/api/s3/files/${id}`, {
                headers: this.getHeaders(),
            });
            if (!response.ok) {
                const error = yield response.json().catch(() => ({}));
                throw new Error(error.message || '파일 조회에 실패했습니다');
            }
            return response.json();
        });
    }
}
exports.FileAPI = FileAPI;
